export type LocationIdValue = number | string | null | undefined;

export const normalizeLocationId = (value: LocationIdValue): number => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};
